module.exports = __webpack_public_path__ + "static/media/invite.658b0857.svg";